import * as React from 'react'
import { useLoaderData, useNavigate } from 'react-router-dom';
import { assetsApi, contractorsApi } from '../../api-interface';
import { AnalysisResponse, Contractor } from '../../api';
import { Box, Button, Tooltip, Typography, useTheme } from '@mui/material';
import { TenantContext } from '../..';
import { useSnackbar } from 'notistack';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import StyledDataGrid, { stringFilterOperators } from '../../components/common/StyledDataGrid/StyledDataGrid';
import UnstyledLink from '../../components/common/UnstyledLink/UnstyledLink';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import DeleteIcon from '@mui/icons-material/Delete'






export async function loader(tenant_id) {
  const contractors = await contractorsApi(tenant_id).getContractorsContractorsGet();
  const ret = contractors.data;
  return ret;
}

const Contractors = () => {
  const contractors = useLoaderData() as Contractor[];
  const theme = useTheme()
  const tenant_id = React.useContext(TenantContext)
  const enqueueSnackbar = useSnackbar().enqueueSnackbar;
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', flex: 1, minWidth: 100, headerClassName: 'table-header' },
    { field: 'created_at', headerName: 'Created At', flex: 1, minWidth: 100, headerClassName: 'table-header' },
    { field: 'notes', headerName: 'Notes', flex: 1, minWidth: 100, headerClassName: 'table-header' },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      headerClassName: 'table-header',
      flex: 1,
      minWidth: 100,
      getActions: (params) => [
        <UnstyledLink to={params.row.id}>
          <Tooltip title="View Contractor Info">
            <AnalyticsIcon sx={{ verticalAlign: 'middle' }} />
          </Tooltip>
        </UnstyledLink>,
        <Tooltip title="Delete Contractor">
          <DeleteIcon sx={{ ml: 1, verticalAlign: 'middle' }} onClick={async () => {
            if (window.confirm("Are you sure you want to remove this contractor? Associated inspections will be dissociated")) {
              try {
                await contractorsApi(tenant_id).deleteContractorContractorsContractorIdDelete(params.row.id);
                enqueueSnackbar("Contractor deleted", { variant: "success" })
                navigate("")
              } catch (e) {
                enqueueSnackbar("Error deleting contractor: " + e, { variant: "error" })
              }
            }
          }} cursor="pointer" />
        </Tooltip>
      ],
    }
  ];

  const rows: GridRowsProp = contractors.map((contractor: Contractor) => {
    return {
      id: contractor.id,
      name: contractor.name,
      created_at: new Date(contractor.date_added).toLocaleDateString(),
      notes: contractor.notes || "No notes"
    }
  });

  return (
    <Box display="flex" flexDirection={"column"} gap={5}>
      <Box display="flex" flexDirection={"row"} justifyContent={"space-between"}>
        <Typography variant="h4" >Contractors</Typography>
                <UnstyledLink to="add">
                  <Button variant="contained">New</Button>
                </UnstyledLink>
      </Box>

      <Box sx={{
        // mt: 5,
        width: '100%'
      }} >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <StyledDataGrid rows={rows} columns={columns} showToolbar initialState={{
            columns: {
              columnVisibilityModel: {
                address_2: false,
                city: true,
                postcode: false,
              },
            },
          }} />
        </div>
      </Box>

    </Box>
  )
}

export default Contractors